import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Button, Table, Input, Form, FormGroup, Label, Col } from 'reactstrap';
import moment from 'moment';
import { connect } from 'react-redux';

class VaxxRecord extends Component {
    static displayName = VaxxRecord.name;

    constructor(props) {
        super(props);
        this.state = {
            permissionFlag: true,
            browser: `${browserName}${browserVersion}`,
            returnable: [],
            ip: "",
            archiveData: [],
            readyToRender: false,
            potentialTargets: [],
            selectedPerson: "DEFAULT"
        }
        this.getUserInfo();
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: this.props.reduxData.userInfo
        });
        this.getData();
        this.testPermission();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        //this.recordComingHere();
    }

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "1036"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "1036",
    //        department: this.props.reduxData.userInfo.level.pk,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    componentDidMount() {

    }

    async findPersons(e) {//This will need to know the search string the user is looking for and what that search string means. The returned data will populate the main dropdown.
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const dataInput = new FormData(e.target);
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            type: dataInput.get('type'),
            search: dataInput.get('search')
        }
        const response = await fetch('GetVaxOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            potentialTargets: data,
            selectedPerson: "DEFAULT",
            readyToRender: false
            })
    }

    async getVaxData(pcid) {//Once a person has been selected, we can get all of their vaccination data from Qualtrics
        this.setState({
            selectedPerson: pcid
        })
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            targetpcid: pcid
            }
        const response = await fetch('GetVaxData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            archiveData: data,
            readyToRender: true
            })
    }

    tableDisplay() {
        return (
            <div>
                <div className="rightAlignCustom">{/*These are download buttons for the most important part of this, the vaxx record card and/or the exemptions form. Only the relevant buttons should show*/}
                    {this.state.archiveData.q13link.length > 0 && <a download href={"/Documents/Qualtrics/Q13/" + this.state.archiveData.q13link}><Button>Download Front<br />{this.state.archiveData.q13link}</Button></a>}&nbsp;
                    {this.state.archiveData.q14link.length > 0 && <a download href={"/Documents/Qualtrics/Q14/" + this.state.archiveData.q14link}><Button>Download Back<br />{this.state.archiveData.q14link}</Button></a>}
                    {this.state.archiveData.q20link.length > 0 && <a download href={"/Documents/Qualtrics/Q20/" + this.state.archiveData.q20link}><Button>Download Medical Exemption<br />{this.state.archiveData.q20link}</Button></a>}
                    {this.state.archiveData.q21link.length > 0 && <a download href={"/Documents/Qualtrics/Q21/" + this.state.archiveData.q21link}><Button>Download Religious Exemption<br />{this.state.archiveData.q21link}</Button></a>}
                </div>
            <Table>
                <thead>{/*This is just for formatting to make sure it looks nice*/ }
                    <tr>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                    <tbody>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Recorded Date</b></td>
                            <td className={"w-75"}>{this.state.archiveData.recordeddate}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Recipient Name</b></td>
                            <td className={"w-75"} >{this.state.archiveData.recipientname}
                            </td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Recipient Email</b></td>
                            <td className={"w-75"}>{this.state.archiveData.recipientemail}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>People Code ID</b></td>
                            <td className={"w-75"}>{this.state.archiveData.pcid}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Current Hood Address</b></td>
                            <td className={"w-75"}>{this.state.archiveData.currenthoodaddr}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Hood Role</b></td>
                            <td className={"w-75"}>{this.state.archiveData.hoodrole}</td>
                        </tr>
                        {/*These commented out options are ones that are being returned but we don't need to display them for the moment. We'll hold onto them just in case.*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>First Name</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.firstname}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Last Name</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.lastname}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Email Address</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.emailaddr}</td>*/}
                        {/*</tr>*/}
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Is Fully Vaccinated?</b></td>
                            <td className={"w-75"}>{this.state.archiveData.isfullvaxx}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Planning on Full Vaccination?</b></td>
                            <td className={"w-75"}>{this.state.archiveData.planfullvaxx}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Vaccine Version</b></td>
                            <td className={"w-75"}>{this.state.archiveData.vaxxversion}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>First Dose Date</b></td>
                            <td className={"w-75"}>{this.state.archiveData.firstdosedate}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>First Dose Facility</b></td>
                            <td className={"w-75"}>{this.state.archiveData.firstdosefacility}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>First Dose Batch</b></td>
                            <td className={"w-75"}>{this.state.archiveData.firstdosebatch}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Second Dose Date</b></td>
                            <td className={"w-75"}>{this.state.archiveData.seconddosedate}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Second Dose Facility</b></td>
                            <td className={"w-75"}>{this.state.archiveData.seconddosefacility}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Second Dose Batch</b></td>
                            <td className={"w-75"}>{this.state.archiveData.seconddosebatch}</td>
                        </tr>
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Card Front ID</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.cardfrontid}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Card Front File Name</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.cardfrontfile}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Card Front File Size</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.cardfrontsize}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Card Front File Type</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.cardfronttype}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Card Back ID</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.cardbackid}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Card Back File Name</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.cardbackfile}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Card Back File Size</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.cardbacksize}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Card back File Type</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.cardbacktype}</td>*/}
                        {/*</tr>*/}
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Got a Booster?</b></td>
                            <td className={"w-75"}>{this.state.archiveData.didboost}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Booster Version</b></td>
                            <td className={"w-75"}>{this.state.archiveData.boosterversion}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Booster Date</b></td>
                            <td className={"w-75"}>{this.state.archiveData.boostdate}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Booster Facility</b></td>
                            <td className={"w-75"}>{this.state.archiveData.boostfacility}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Booster Batch</b></td>
                            <td className={"w-75"}>{this.state.archiveData.boostbatch}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Confirm this is true?</b></td>
                            <td className={"w-75"}>{this.state.archiveData.confirmtrue}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Select an Exemption</b></td>
                            <td className={"w-75"}>{this.state.archiveData.selectexempt}</td>
                        </tr>
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Medical Exemption ID</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.medexemptid}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Medical Exemption File Name</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.medexemptfile}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Medical Exemption File Size</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.medexemptsize}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Medical Exemption File Type</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.medexempttype}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Religious Exemption ID</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.relexemptid}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Religious Exemption File Name</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.relexemptfile}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Religious Exemption File Size</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.relexemptsize}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>Religious Exemption File Type</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.relexempttype}</td>*/}
                        {/*</tr>*/}
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Vaccination Status</b></td>
                            <td className={"w-75"}>{this.state.archiveData.vaxxstatus}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Booster 1 Date</b></td>
                            <td className={"w-75"}>{this.state.archiveData.boost1date}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Booster 2 Date</b></td>
                            <td className={"w-75"}>{this.state.archiveData.boost2date}</td>
                        </tr>
                        {/*<tr>*/}
                        {/*    <td className={"w-25"} style={{ textAlign: 'right' }}>VSMID2</td>*/}
                        {/*    <td className={"w-75"}>{this.state.archiveData.vsmid2}</td>*/}
                        {/*</tr>*/}
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Booster Day</b></td>
                            <td className={"w-75"}>{this.state.archiveData.boosterday}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Vaccine Dose</b></td>
                            <td className={"w-75"}>{this.state.archiveData.vaccinedose}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Booster Dose</b></td>
                            <td className={"w-75"}>{this.state.archiveData.boosterdose}</td>
                        </tr>
                        <tr>
                            <td className={"w-25"} style={{ textAlign: 'right' }}><b>Classification</b></td>
                            <td className={"w-75"}>{this.state.archiveData.classification}</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        );//Yeah, I know, okay? I didn't enjoy this either.
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        let displayInfo = <div></div>
        if (this.state.readyToRender == true) displayInfo = this.tableDisplay();
        return (//Users need to be picking one person in particular here. To streamline, we'll provide an option to search for one of four types and that'll dictate what the text box is for.
            <div>
                <div className="inlineCustom">
                    <Form onSubmit={this.findPersons.bind(this)} className="d-flex">
                        <FormGroup>
                            <Label>Search Type</Label>
                            <Input type="select" name="type" id="type">
                                <option disabled selected>Type...</option>
                                <option value="FN">First/Nickname</option>
                                <option value="LN">Last Name</option>
                                <option value="ID">PCID</option>
                                <option value="EM">Email Address</option>
                            </Input>
                        </FormGroup>
                        &nbsp;
                        <FormGroup>
                            <Label>Search String</Label>
                            <Input type="text" name="search" id="search" />
                        </FormGroup>
                        <Button outline type="submit" color="success">Search</Button>
                    </Form>
                </div>
                &nbsp;
                {this.state.potentialTargets.length > 0 && <div className="inlineCustom">
                    <Input type="select" name="choice" id="choice" onChange={(e) => this.getVaxData(e.target.value)} value={this.state.selectedPerson}>
                        <option value="DEFAULT" disabled>Select Person...</option>
                        {this.state.potentialTargets.map(item => (
                            <option value={item.pcid}>{item.name}</option>
                        ))}
                    </Input>
                    </div>}
                {/*Once the values have been searched, some potential hits will fill the second dropdown and let it appear. There's too much data to be able to select more than one person, especially with download links*/}
                <br />
                {displayInfo}
            </div>
        );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(VaxxRecord);